<header class="header header--gradient">

  <div class="header__logo">
    <a [routerLink]="'/marketplace/shared-devices/' | localize">
      <img src="assets/images/logo-dwall.svg" alt="">
    </a>
  </div>

  <ul class="header__nav">
    <li class="header__nav-item">
      <a class="header__nav-link" [routerLink]="'/marketplace/shared-devices/' | localize" routerLinkActive="active">{{'tv-owner.common.sharedDevices' | translate}}</a>
    </li>
    <li class="header__nav-item">
      <a class="header__nav-link" [routerLink]="'/marketplace/campaigns' | localize" routerLinkActive="active">{{'advertiser.common.campaigns' | translate}}</a>
    </li>
    <li class="header__nav-item">
      <a class="header__nav-link" [routerLink]="'/marketplace/billing' | localize" routerLinkActive="active">{{'advertiser.common.billing' | translate}}</a>
    </li>
  </ul>

  <div class="header__control">
    <button type="button" class="dw-btn marketplace dw-btn-dwall" [routerLink]="'/app/devices'">Dwall.online</button>
    <div class="header__control-item money">
      <span>${{(balance$ | async)}}</span>
    </div>
    <div class="header__control-item subscribe">
      <button type="button" class="dw-btn marketplace dw-btn--transparent">{{'app.appHeader.button' | translate}}</button>
    </div>
    <div class="header__control-item language">
      <div class="language-select-marketplace">
        <ng-select [ngModel]="lang"
                   [items]="languages"
                   bindValue="value"
                   [searchable]="false"
                   [clearable]="false"
                   (ngModelChange)="setLang($event)"
        >
          <ng-template ng-label-tmp let-item="item">
            {{'landing.header.lang.' + item.value | translate | slice: 0: 3 }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            {{'landing.header.lang.' + item.value | translate }}
          </ng-template>
        </ng-select>
      </div>
    </div>
    <div class="header__control-item settings">
      <div class="header__settings">
        <span class="header__settings-icon">
        <img src="assets/images/user-logo.svg" alt="user logo">
      </span>
        <div class="header__settings-nav">
          <a [routerLink]="'/app/user' | localize">{{'app.common.settings' | translate}}</a>
          <a href="#">{{'app.myAccount.logout' | translate}}</a>
        </div>
      </div>
    </div>
  </div>
</header>
